/* eslint-disable @typescript-eslint/no-empty-function */
import BookmarkAddedOutlinedIcon from "@mui/icons-material/BookmarkAddedOutlined";
import BookmarkRemoveOutlinedIcon from "@mui/icons-material/BookmarkRemoveOutlined";
import IconButton from "@mui/material/IconButton";
import LineChartCubeResponse from "../../../Hooks/LineChartCubeResponse";
import { Tooltip } from "@mui/material";
import { useMemo, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import MarkUnreadChatAltOutlinedIcon from "@mui/icons-material/MarkUnreadChatAltOutlined";
import Box from "@material-ui/core/Box";
import ReactCardFlip from "react-card-flip";
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CustomScrollbars from "../../../../../componets/CustomScrollbars/CustomScrollbars";
import moment from "moment";
function AccordionKPIBlock({
  title,
  isCollapsed,
  onToggleCollapse,
  isExtended,
  onToggleExtend,
  tag,
  dateRange,
  granularity,
  measureType,
  unit,
  setExcelData = () => {},
  fetchedAnnotations,
  addCompareAsset,
  removeCompareAsset,
  compareAssets,
  isMoldAssetName,
  renderChart = true,
}: any) {
  const isAddedToCompare = useMemo(
    () => Boolean(compareAssets.find((asset: any) => asset.key === tag)),
    [compareAssets, tag]
  );

  const [expanded, setExpanded] = useState(true);
  const [showAnnotations, setShowAnnotations] = useState(false);

  const handleExpandClick = (event: any) => {
    event.stopPropagation();
    setExpanded(!expanded);
  };

  return (
    <>
      <Accordion expanded={expanded}>
        <AccordionSummary
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{
            minHeight: "50px !important", // Ensure it doesn't expand
            height: "50px", // Set fixed height
            "&.root .MuiAccordionSummary-root": {
              minHeight: "45px",
            },
            ".MuiAccordionSummary-content": {
              margin: "0px", // Default margin when collapsed
              transition: "margin 0.3s ease-in-out",
            },
            "&.Mui-expanded .MuiAccordionSummary-content": {
              margin: "0px", // Apply margin when expanded
              minHeight: "",
            },
          }}
        >
          <Typography variant="h4" sx={{ lineHeight: 3 }}>
            {title}
          </Typography>
          <Box
            style={{
              marginLeft: "auto",
              display: "flex",
              alignItems: "center",
            }}
          >
            {fetchedAnnotations.filter((ele: any) => {
              return ele["Annotations.tagName"] === tag;
            }).length > 0 ? (
              <Tooltip
                title={showAnnotations ? "Hide Annotation" : "Show Annotation"}
              >
                <IconButton
                  aria-label="edit"
                  onClick={() => {
                    setShowAnnotations(!showAnnotations);
                  }}
                >
                  {showAnnotations ? (
                    <DisabledByDefaultOutlinedIcon />
                  ) : (
                    <MarkUnreadChatAltOutlinedIcon />
                  )}
                </IconButton>
              </Tooltip>
            ) : (
              // <Button
              // 	style={{ margin: '0em 0.5em' }}
              // 	variant='outlined'

              // >
              // 	{showAnnotations ? 'Hide Annotations' : 'Show Annotations'}
              // </Button>
              <></>
            )}

            {isAddedToCompare ? (
              <Tooltip title="Remove from Compare">
                <IconButton
                  aria-label="edit"
                  sx={{ color: "red" }}
                  onClick={() => removeCompareAsset(tag, isMoldAssetName)}
                >
                  <BookmarkRemoveOutlinedIcon />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Add to Compare">
                <IconButton
                  aria-label="edit"
                  onClick={() => addCompareAsset(tag, isMoldAssetName)}
                >
                  <BookmarkAddedOutlinedIcon />
                </IconButton>
              </Tooltip>
            )}

            {/* <Tooltip title="Expand Visual">
              <IconButton aria-label="edit" onClick={onToggleExtend}>
                <OpenInFullIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Expand View">
              <IconButton aria-label="expand" onClick={handleExpandClick}>
                {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </Tooltip> */}
            <Tooltip title={isExtended ? 'Collapse Visual' : 'Expand Visual'}>
							<IconButton aria-label='edit' onClick={onToggleExtend}>
								<OpenInFullIcon />
							</IconButton>
						</Tooltip>
						<Tooltip title= {expanded ? 'Collapse View': 'Expand View'}>
							<IconButton aria-label='expand' onClick={handleExpandClick}>
								{expanded ? (
									<ExpandLessIcon />
								) : (
									<ExpandMoreIcon />
								)}
							</IconButton>
						</Tooltip>
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: "7.5px" }}>
          <ReactCardFlip isFlipped={showAnnotations} flipDirection="horizontal">
            { renderChart && <LineChartCubeResponse
              tag={tag}
              isExtended={isExtended}
              dateRange={dateRange}
              granularity={granularity}
              measureType={measureType}
              setExcelData={setExcelData}
              unit={unit}
              fetchedAnnotations={fetchedAnnotations.filter((ele: any) => {
                return ele["Annotations.tagName"] === tag;
              })}
            /> }
            

            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 100 }}
                stickyHeader
                aria-label="simple table"
                size="small"
              >
                <CustomScrollbars
                  autoHeight={true}
                  autoHeightMin={"30em"}
                  autoHide={false}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={{
                          width: "45%",
                        }}
                      >
                        Annotation
                      </TableCell>
                      <TableCell
                        style={{
                          width: "25%",
                        }}
                        align="left"
                      >
                        Added by
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          width: "25%",
                        }}
                      >
                        Annotated Time
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          width: "5%",
                        }}
                      >
                        Value
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {fetchedAnnotations
                      .filter((ele: any) => {
                        return ele["Annotations.tagName"] === tag;
                      })
                      .map((row: any) => (
                        <TableRow
                          key={row.name}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {row["Annotations.user_annotation"].substring(
                              row["Annotations.user_annotation"].indexOf(":") +
                                1,
                              row["Annotations.user_annotation"].length
                            )}
                          </TableCell>
                          <TableCell align="left">
                            {row["Annotations.user_annotation"].substring(
                              0,
                              row["Annotations.user_annotation"].indexOf(":")
                            )}
                          </TableCell>
                          <TableCell align="left">
                            {moment(
                              row["Annotations.timestamp"].substring(0, 10)
                            )
                              .add(-360, "minutes")
                              .format("M/DD/YY hh:mmA")}
                          </TableCell>
                          <TableCell align="left">
                            {row["Annotations.datapoint"]}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </CustomScrollbars>
              </Table>
            </TableContainer>
          </ReactCardFlip>
        </AccordionDetails>
      </Accordion>
      {/* <Card style={{ background: '#293368', padding: '8px' }}>
			<CardHeader
				style={{ padding: '0px' }}
				action={
					<>
						<Tooltip title="Add to Compare">
							<Button
								variant='outlined'
								onClick={() => addCompareAsset(tag)}
								sx={{ display: isAddedToCompare ? 'none' : 'unset', width: '75px' }}
							>
								<BookmarkAddedOutlinedIcon />
							</Button>
						</Tooltip>
						<Tooltip title="Remove from Compare">
							<Button
								variant='contained'
								color='error'
								onClick={() => removeCompareAsset(tag)}
								sx={{ display: isAddedToCompare ? 'unset' : 'none', width: '75px' }}
							>
								<BookmarkRemoveOutlinedIcon />
							</Button>
						</Tooltip>

						<IconButton aria-label='expand fullscreen' onClick={onToggleExtend}>
							{isExtended ? (
								<CloseFullscreenIcon fontSize='medium' />
							) : (
								<ExtendIcon />
							)}
						</IconButton>
						<IconButton aria-label='collapse graph' onClick={onToggleCollapse}>
							{isCollapsed ? (
								<KeyboardArrowDownIcon fontSize='large' />
							) : (
								<KeyboardArrowUpIcon fontSize='large' />
							)}
						</IconButton>
					</>
				}
				title={title}
			/>
			{!isCollapsed && (
				<CardContent style={{ padding: '5px 0px' }}>
					<LineChartCubeResponse
						tag={tag}
						isExtended={isExtended}
						dateRange={dateRange}
						granularity={granularity}
						measureType={measureType}
						setExcelData={setExcelData}
						unit={unit}
						fetchedAnnotations={fetchedAnnotations}
					/>
				</CardContent>
			)}
		</Card> */}
    </>
  );
}

export default AccordionKPIBlock;
